import React from "react";

const ReturnUrlValidationErrorRedirect = (props) => {
    const {errorRedirect} = props;
    window.location.replace(errorRedirect);
    return(<></>);
};

export default ReturnUrlValidationErrorRedirect;